import { useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Input, addToast, Chip, Card, CardBody, RadioGroup, Radio } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_CLIENT_SETTING_VAL, ENUM_CURRENCY_SETTING_VAL, ENUM_INPUT_TYPE, ENUM_MIXSLIT_ENTRYTYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, ENUM_TRADEOF_CODE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { usePost } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faGem, faSave, faSquareXmark, } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { calculateTotal, calculateTotalWeight, funCheckNumber, scrollInput } from "../../Utility/utility"
import { Box, } from "@mui/material"
import { setIsMemoRedirect, setRedirectLink } from "../../state/accountSlice"


const CreateSingleMixSlitEntry = () => {
    const { compCode, isMultipleCompany, compState } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.mixslitEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { mtrdtype, mptype } = useParams();
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")
    //const [selBillType, setSelBillType] = useState("")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [ClientSetting, setClientSetting] = useState("")
    const [naviCode, setnaviCode] = useState("")
    const dispatch = useDispatch();
    const [lwRatioData, setLwRatioData] = useState([])
    const gridContainerRef = useRef(null);
    const [mktLotNo, setMktLotNo] = useState("0")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)

    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMasterData } = usePost({
        url: apiRoute.mixslitEntry.entryMasterData,
        queryKey: "fetchMemoMasterData",

    })
    const { data: mktLotNoData = [], mutate: getMktLotNo } = usePost({
        url: apiRoute.memoEntry.fetchMktlotNo,
        queryKey: "getmktlocdeData",
        onSuccessTasks: (data) => {
            if (!isUseMfgNoAsMktno) {
                if (data && data.length <= 0) {
                    setMktLotNo("")
                    if (!toast.isActive("mktlcode")) {
                        toast.error("Lot No Series Not Found", {
                            "position": "top-center",
                            toastId: "mktlcode"
                        })
                    }
                    setFormData({ ...formData, [formField.mDate]: null })
                }
                else {
                    setMktLotNo(data[0].Mkt_LCode)
                }
            }
            else
                setMktLotNo('0')

        }

    })
    const funMktLotNo = (date) => {
        if (isNewEntry && !isUseMfgNoAsMktno) {
            getMktLotNo({
                data: {
                    chaldate: date
                }
            })
        }
    }
    useEffect(() => {
        funMktLotNo(dayjs(Date()).format("YYYY-MM-DD"))
    }, [isUseMfgNoAsMktno])

    const [selMixSlitType, setSelMixSlitType] = useState(ENUM_MIXSLIT_ENTRYTYPE.SingleToMix)
    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePost({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    if (!toast.isActive('toats_chkpktlot')) {
                        toast.error("Duplicate Pkt No And Lot No Not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkpktlot",


                        })
                    }
                    setFormData({ ...formData, [formField.lotNo]: "", [formField.pktNo]: "" })
                }
            }
        }


    })

    const { data: dupRoughNo = [], mutate: funChkRoughNo } = usePost({
        url: apiRoute.memoEntry.checkRoughNo,
        queryKey: "checkRoughtNo",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {


                    if (!toast.isActive('toats_chkRoughno')) {
                        toast.error("Duplicate Rough No not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkRoughno",
                        })
                    }

                    setFormData({ ...formData, lotNo: "" })
                }
            }

        }

    })


    const { data: stockData = [], mutate: filterStockData } = usePost({
        url: apiRoute.memoEntry.fetchStockData,
        queryKey: "fetchStockData",
        onSuccessTasks: (data) => {
            let index = selectedGridRowId
            if (data && data.length > 0) {
                console.log(data)
                const newRows = [...rows]

                newRows[index][RowsField.itemCode] = data[0].ItemCode
                newRows[index][RowsField.shapeCode] = data[0].ShapeCode
                newRows[index][RowsField.sizeCode] = data[0].SizeCode
                newRows[index][RowsField.colorCode] = data[0].ColorCode
                newRows[index][RowsField.purityCode] = data[0].PurityCode
                newRows[index][RowsField.reportNo] = data[0].ReportNo
                newRows[index][RowsField.lab] = data[0].Lab
                newRows[index][RowsField.lwRatio] = data[0].LwRatio
                newRows[index][RowsField.stkPcs] = data[0].BPcs
                newRows[index][RowsField.stkWeight] = data[0].BWeight
                newRows[index][RowsField.stkRate] = data[0].BRated
                newRows[index][RowsField.stkDRate] = data[0].BRated
                newRows[index][RowsField.rapRate] = data[0].RapRate
                newRows[index][RowsField.discPer] = data[0].LessPer
                newRows[index][RowsField.sLotNo] = data[0].SLotNo
                newRows[index][RowsField.sPktNo] = data[0].SPktNo
                newRows[index][RowsField.pcs] = data[0].BPcs
                newRows[index][RowsField.weight] = data[0].BWeight
                newRows[index][RowsField.convRate] = data[0].CRate
                const calData = funCalAllAmount(newRows, index, 0, 0)
                newRows[index].amount = calData.amount
                newRows[index].dAmount = calData.dAmount
                // if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
                // newRows[index].rate = calData.rate
                setRows(newRows)
            }
            else {

                if (!toast.isActive("toast_stock")) {
                    toast.error("Stock Not Found", {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_stock"
                    })
                }
                const newRows = [...rows]
                newRows[index][RowsField.pktNo] = ""
                newRows[index][RowsField.lotNo] = ""
                setRows(newRows)
            }
        }

    })
    const funGenVouNo = (tradeOf) => {
        if (tradeOf != "") {
            generateVouNo({
                data: {
                    comp_code: compCode.join(","),
                    trade_of: tradeOf,

                }

            })
        }
    }

    const onSuccessVouno = (data) => {
        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: String(data[0]?.new_vou_no ?? ''),
            }))
        }
    }
    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.mixslitEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: onSuccessVouno
    })

    const onSuccessTasks = (data) => {
        navigate(funGetMasterLink());
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.mixslitEntry.add_update,
        queryKey: "funAddUpdateMixSlit",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.mixslitEntry.fetchEntryDetail,
        queryKey: "fetchMemoDetail",
    });



    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })

    const isSinglePacket = () => {
        if (mptype != "") {
            if (mptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }
    let gridData = []
    //   useEffect(() => {
    //         const cleanup = scrollInput({ ignoreRefs: [gridContainerRef] });
    //         return () => cleanup();
    //     }, []);
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
        if (!params.includes(String(mtrdtype))

            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(mptype))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (mtrdtype && mtrdtype != "" && mptype && mptype != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_pktType = ''
            let t_trdtype = mtrdtype.toLowerCase()
            let modName = ''

            if (mptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'

            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish Diamond "
                modName = ENUM_MOD_NAME.MixSlitPolishSingle
                setnaviCode(linksUrl.mixslitEntry.polishDiamond)
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough Diamond "
                modName = ENUM_MOD_NAME.MixSlitRoughSingle
                setnaviCode(linksUrl.mixslitEntry.roughDiamond)
            }

            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            filterMasterData({
                data: {
                    compcode: compCode.join(","),
                    tradeof: t_tradeof,
                }
            })
            if (isNewEntry)
                funGenVouNo(t_tradeof)
            filterModSetting({
                data: {
                    page_mod: modName,
                    master_mod: ENUM_MOD_NAME.GeneralSettings
                }
            })

            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, trade_of } = detailParams

                funGetDetail({
                    data: {
                        compcode: String(comp_code),
                        transactionid: transaction_id,
                        tradeof: trade_of
                    }
                })
            }
        }
    }, [mptype, mtrdtype])

    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, generalData);
            setIsUseMfgNoAsMktno(mktSetting)
            const client_Type = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.ClientSettingType, generalData) ?? ENUM_CLIENT_SETTING_VAL.DUAL
            if (isNewEntry && client_Type == ENUM_CLIENT_SETTING_VAL.SINGLE)
                setSelMixSlitType(ENUM_MIXSLIT_ENTRYTYPE.SingleToSingle)
            setClientSetting(client_Type)
            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.rapRate]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.RapRate, modData) ?? false,
                    [RowsField.discPer]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.DiscPer, modData) ?? false,
                    [RowsField.remarks]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Remarks, modData) ?? false,

                },
                Value: {
                    [RowsField.itemCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,


                },
                Mandatory: {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.rapRate]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.RapRate, modData) ?? false,
                    [RowsField.discPer]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.DiscPer, modData) ?? false,
                    [RowsField.remarks]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Remarks, modData) ?? false,

                },


            })
        }

    }, [modSetting])

    const funGetAmtD = (carat, rate, crate) => {
        let dRate = parseFloat(rate ?? 0) / parseFloat(crate ?? 0)
        let amt = parseFloat(carat ?? 0) * parseFloat(dRate ?? 0)
        return funCheckNumber(amt).toFixed(2)
    }

    const funGetAmt = (carat, rate,) => {
        let amt = parseFloat(carat ?? 0) * parseFloat(rate ?? 0)
        return funCheckNumber(amt).toFixed(2)
    }

    const formField = {
        transId: "transId",
        vouNo: "vouNo",
        mDate: "mDate",
        locationId: "locationId",
        shapeCode: "shapeCode",
        colorCode: "colorCode",
        purityCode: "purityCode",
        sizeCode: "sizeCode",
        itemCode: "itemCode",
        lotNo: "lotNo",
        pktNo: "pktNo",
        sLotNo: "sLotNo",
        sPktNo: "sPktNo",
        remarks: "remarks",
        detailId: "detailId",
        lwRatio: "lwRatio",
        lab: "lab",
        reportNo: "reportNo",
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.mDate)
            acc[key] = new Date()
        else if (key == formField.transId || key == formField.detailId)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [rows, setRows] = useState([])

    const total_OutAmount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const total_OutWeight = useMemo(
        () =>
            calculateTotalWeight({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const total_OutRate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_OutAmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_OutRateD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dRate",
            }),
        [rows]
    )
    const total_OutPcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )

    const funGetAvgRate = (totalAmt, totalWeight) => {
        let avg = parseFloat(totalAmt) / parseFloat(totalWeight)
        return funCheckNumber(avg).toFixed(2)
    }


    const Avg_Rate = useMemo(() => funGetAvgRate(total_OutAmount, total_OutWeight), [rows])
    const Avg_RateD = useMemo(() => funGetAvgRate(total_OutAmountD, total_OutWeight), [rows])
    const RowsField = {
        detailId: "detailId",
        id: "id",
        transId: "transId",
        gridId: "gridId",
        itemCode: "itemCode",
        itemName: "itemName",
        shapeName: "shapeName",
        shapeCode: "shapeCode",
        pktNo: "pktNo",
        lotNo: "lotNo",
        sPktNo: "sPktNo",
        sLotNo: "sLotNo",
        purityName: "purityName",
        purityCode: "purityCode",
        colorName: "colorName",
        colorCode: "colorCode",
        sizeName: "sizeName",
        sizeCode: "sizeCode",
        lwRatio: "lwRatio",
        amount: "amount",
        stkRate: "stkRate",
        stkDRate: "stkDRate",
        stkPcs: "stkPcs",
        stkWeight: "stkWeight",
        pcs: "pcs",
        weight: "weight",
        rate: "rate",
        rapRate: "rapRate",
        discPer: "discPer",
        remarks: "remarks",
        reportNo: "reportNo",
        lab: "lab",
        oldWeight: "oldWeight",
        oldPcs: "oldPcs",
        convRate: "convRate",
        dRate: "dRate",
        dAmount: "dAmount",
        bPcs: "bPcs",
        bWeight: "bWeight",


    }
    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.transId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.shapeName]: "",
        [RowsField.shapeCode]: "",
        [RowsField.pktNo]: "",
        [RowsField.lotNo]: "",
        [RowsField.sPktNo]: "",
        [RowsField.sLotNo]: "",
        [RowsField.purityName]: "",
        [RowsField.purityCode]: "",
        [RowsField.colorName]: "",
        [RowsField.colorCode]: "",
        [RowsField.sizeName]: "",
        [RowsField.sizeCode]: "",
        [RowsField.lwRatio]: "",
        [RowsField.stkRate]: 0,
        [RowsField.stkDRate]: 0,
        [RowsField.amount]: 0,
        [RowsField.stkPcs]: 0,
        [RowsField.stkWeight]: 0,
        [RowsField.oldWeight]: 0,
        [RowsField.oldWeight]: 0,
        [RowsField.rapRate]: 0,
        [RowsField.discPer]: 0,
        [RowsField.bPcs]: 0,
        [RowsField.bWeight]: 0,
        [RowsField.pcs]: 0,
        [RowsField.weight]: 0,
        [RowsField.amount]: 0,
        [RowsField.rate]: 0,
        [RowsField.remarks]: "",
        [RowsField.convRate]: 0,
        [RowsField.dRate]: 0,
        [RowsField.dAmount]: 0,



    }

    const itemGridHeadClass = "bill-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

            gridData = detail?.itemDetail.map((item, i) => {
                return {
                    ...initialRow,
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    pcs: item?.Pcs ?? 0,
                    weight: item?.Carat ?? 0,
                    rate: item?.Rs_Rate ?? 0,
                    convRate: item?.C_Rate ?? 0,
                    dRate: item?.D_Rate ?? 0,
                    transId: item?.TransactionId ?? 0,
                    amount: funGetAmt(item?.Carat ?? 0, item?.Rs_Rate ?? 0),
                    dAmount: funGetAmtD(item?.Carat ?? 0, item?.Rs_Rate ?? 0, item?.C_Rate ?? 0),
                    detailId: item?.DetailId ?? 0,
                    lotNo: item?.L_Code ?? "",
                    pktNo: item?.PktNo ?? "",
                    sPktNo:item?.SPktNo ?? "",
                    sLotNo:item?.SL_Code ?? "",
                    lwRatio: item?.Lw_Code ?? "",
                    shapeCode: item?.S_Code ?? "",
                    colorCode: item?.Sha_Code ?? "",
                    purityCode: item?.Q_Code ?? "",
                    sizeCode: item?.Sz_Code ?? "",
                    remarks: item?.Remarks ?? "",
                    oldPcs: item?.Pcs ?? "",
                    oldWeight: item?.Carat ?? "",
                }
            })


        }
    }


    const inputBoxes = {
        Row1: [
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Vou No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.mDate,
                name: formField.mDate,
                placeholder: "Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],
        Row2: [
            {
                id: formField.shapeCode,
                name: formField.shapeCode,
                placeholder: "New Shape",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.shapeMaster ? masterData?.shapeMaster : [],
                itemkey: "S_Code",
                itemvalue: "S_Name",
                isrequired: true,
            },
            {
                id: formField.colorCode,
                name: formField.colorCode,
                placeholder: "New Color",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.colorMaster ? masterData?.colorMaster : [],
                itemkey: "Sh_Code",
                itemvalue: "Sh_Name",
                isrequired: true,
            },
        ],
        Row3: [
            {
                id: formField.purityCode,
                name: formField.purityCode,
                placeholder: "New Purity",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.purityMaster ? masterData?.purityMaster : [],
                itemkey: "Q_Code",
                itemvalue: "Q_Name",
                isrequired: true,
            },
            {
                id: formField.sizeCode,
                name: formField.sizeCode,
                placeholder: "New Size",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.sizeMaster ? masterData?.sizeMaster : [],
                itemkey: "Sz_Code",
                itemvalue: "Sz_Name",
                isrequired: true,
            },
        ],
        Row4: [
            {
                id: formField.lotNo,
                name: formField.lotNo,
                placeholder: "New Lot No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.pktNo,
                name: formField.pktNo,
                placeholder: "New Pkt No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row5: [
            {

                id: formField.lwRatio,
                name: formField.lwRatio,
                placeholder: "New LxW Code",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: lwRatioData ? lwRatioData : [],
                itemkey: "LwCode",
                itemvalue: "LwCode",
                isrequired: false,
                // id: formField.lwRatio,
                // name: formField.lwRatio,
                // placeholder: "New LxW Code",
                // type: ENUM_INPUT_TYPE.text,
                // size: "sm",
                // label: "",
                // isrequired: true,
            },
            {
                id: formField.itemCode,
                name: formField.itemCode,
                placeholder: "New Item",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.itemMaster ? masterData?.itemMaster : [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                isrequired: false,
            },
        ],
        Row6: [{
            id: formField.remarks,
            name: formField.remarks,
            placeholder: "Remarks",
            type: ENUM_INPUT_TYPE.text,
            size: "sm",
            label: "",
            isrequired: false,
        }]


    }

    const handleBlur = (gridId, index, e, id,is_readonly) => {
        if(is_readonly)
            return;
        
        const { value } = e.target

        if (gridId == "new" && (id == formField.lotNo || id == formField.pktNo)) {
            let t_lotno = id == formField.lotNo ? value : formData[formField.lotNo]
            if (selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.SingleToSingle) {
                let t_pktno = id == formField.pktNo ? value : formData[formField.pktNo]

                funChkPktLotNo({
                    data: {
                        compcode: compCode.join(","),
                        lotno: t_lotno,
                        pktno: t_pktno,
                        mktlcode: mktLotNo || '0'
                    }
                })
            }
            else if (selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.SingleToMix && selTradeOf == 'R') {
                funChkRoughNo({
                    data: {
                        compcode: compCode.join(","),
                        roughno: t_lotno,
                    }
                })

            }


        }
        else if ((id == RowsField.lotNo || id == RowsField.pktNo) && gridId != "new") {
            setSelectedGridRowId(index)
            const newRows = [...rows]
            let t_lotno = id == RowsField.lotNo ? value : newRows[index][RowsField.lotNo]
            let t_pktno = id == RowsField.pktNo ? value : newRows[index][RowsField.pktNo]
            let isDuplicate = 0;
            if (selPktType == 'SNG' && t_lotno != "" && t_pktno != "") {
                const pktData = rows.filter((ele, i) => i != index && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                if (pktData && pktData.length > 0) {
                    isDuplicate = 1
                    toast.error("duplicate lot No and Pkt No. not allow", {
                        position: "top-center"
                    })
                    newRows[index][RowsField.lotNo] = ""
                    newRows[index][RowsField.pktNo] = ""
                    setRows(newRows)
                }
            }
            if (!isDuplicate) {
                if (selPktType == 'SNG') {
                    if (t_lotno != "" && t_pktno != "" && !isDisableSubmit()) {
                        filterStockData({
                            data: {
                                compcode: compCode.join(","),
                                lotno: t_lotno,
                                pktno: t_pktno,
                                tradeof: selTradeOf
                            }
                        })
                    }
                }
            }
        }
        else if (id == RowsField.pcs || id == RowsField.weight) {
            let newRows = []
            let chkPcsValue = 0
            let chkWeightValue = 0
            newRows = [...rows]
            chkPcsValue = Number(newRows[index][RowsField.stkPcs]) + Number(newRows[index][RowsField.oldPcs])
            chkWeightValue = parseFloat(newRows[index][RowsField.stkWeight]) + parseFloat(newRows[index][RowsField.oldWeight])

            if (chkPcsValue != "" || chkWeightValue != "") {

                if (id == RowsField.pcs) {
                    if (Number(value) > Number(chkPcsValue)) {
                        toast.error(`Pcs should be less than (${chkPcsValue})`, {
                            "position": "top-center",
                            "className": "toast-error",
                        })
                        newRows[index][RowsField.pcs] = chkPcsValue
                    }

                }
                else if (id == RowsField.weight) {
                    if (parseFloat(value) > parseFloat(chkWeightValue)) {
                        toast.error(`Weight should be less than (${chkWeightValue})`, {
                            "position": "top-center",
                            "className": "toast-error",
                        })
                        newRows[index][RowsField.weight] = chkWeightValue
                    }

                }
                setRows(newRows)
            }

        }

    }


    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const handleAutoCompleteChange = (gridId, value, rowid, name) => {
        const formId = [formField.itemCode, formField.locationId, formField.shapeCode, formField.colorCode, formField.lwRatio, formField.sizeCode, formField.purityCode]
        if (formId.includes(name)) {
            if (name == formField.shapeCode) {
                //const LwByShape = masterData?.lwMaster.filter((ele) => ele.S_Code == value)
                setLwRatioData(getLwRatioByShape(value))
            }
            setFormData({
                ...formData,
                [name]: value,
            })
        }
        else {
            const index = rows.findIndex((ele) => ele.id == rowid)
            setSelectedGridRowId(index)
            let newRow = [...rows]
            newRow[index][name] = value
            setRows(newRow)
        }
    }

    const handleDeleteRow = (gridId, id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)

        const rearrangedRows = updatedRows.map((row, index) => {
            return {
                ...row,
                id: index + 1, // Reassign IDs to start from 1 again
            }
        })

        setRows(rearrangedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])


    }
    const funCalAllAmount = (gridId, rowData, index, pcs, weight, currentID) => {

        let newRows = [...rows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let t_DAmount = 0
        let tempVal = 0

        let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        let t_DRate = newRows[index].dRate && newRows[index].dRate != null ? newRows[index].dRate : 0
        let t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        let t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0



        let conv_rate = newRows[index].convRate && newRows[index].convRate != null ? newRows[index].convRate : 0
        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
            // && CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
            if ((currentID == RowsField.dRate || currentID == RowsField.convRate)) {
                tempVal = parseFloat(t_DRate) * parseFloat(conv_rate)
                t_rate = funCheckNumber(tempVal).toFixed(2)
            }
            else if (currentID == RowsField.rate || currentID == RowsField.convRate) {
                tempVal = parseFloat(t_rate) / parseFloat(conv_rate)
                t_DRate = funCheckNumber(tempVal).toFixed(2)
            }
        }
        tempVal = parseFloat(t_rate) * parseFloat(t_weight)
        t_Amount = funCheckNumber(tempVal)
        tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
        t_DAmount = funCheckNumber(tempVal)


        return { amount: t_Amount.toFixed(2), dAmount: t_DAmount.toFixed(2), dRate: t_DRate, rate: t_rate }

    }
    const handleInputChange = (gridId, rowId, e, name) => {

        let { value, id } = e.target
        let index = 0
        let newRows = []
        index = rows.findIndex(ele => ele.id == rowId)
        newRows = [...rows]
        setSelectedGridRowId(index)

        newRows[index][id] = value
        const CalColumn = [RowsField.rate, RowsField.pcs, RowsField.weight, RowsField.dRate, RowsField.convRate]
        if (CalColumn.includes(id)
        ) {

            const calData = funCalAllAmount(gridId, newRows, index, 0, 0, id)

            newRows[index].amount = calData.amount
            newRows[index].dAmount = calData.dAmount
            if (id != RowsField.dRate && CurrencySetting != ENUM_CURRENCY_SETTING_VAL.Dollar)
                newRows[index].dRate = calData.dRate //.toFixed(2)
            if (id != RowsField.rate && CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS)
                newRows[index].rate = calData.rate//.toFixed(2)
        }
        setRows(newRows)


    }
    const funIsFooter = (id) => {
        if (id == 100)
            return true
        else
            return false
    }

    const isDisableSubmit = () => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0 && (selMixSlitType == 2 || selMixSlitType == 3)) {
            const { status } = detailParams
            if (status == ENUM_STATUS.Final)
                return true
            else
                return false
        }
        return false
    }

    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (

            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                labelPlacement="outside"
                isReadOnly={is_readonly}
               // isDisabled={input_id == RowsField.lotNo || input_id == RowsField.pktNo ? is_readonly : false}
                placeholder={holder_text}
                //allow space in text box
                onBlur={(e) => handleBlur("", row.id - 1, e, RowsField[input_id],is_readonly)}
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                size="sm"
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.gridId, row.id, e, RowsField[input_id])}
                className="max-w-xs mt-1"
                classNames={{
                    input: `${input_type == "number" ? "text-right" : ""}  text-xs `,

                }}
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }
    const renderAutoCompleteCell = (itemData, itemKey, itemValue, row, autocomp_id, autocomp_name, is_readonly, holder_text, is_required, variant, color) => {
        return (
            <Autocomplete
                isRequired={setColumnRequired(RowsField[autocomp_id])}
                size="sm"
                color={color ? color : "default"}
                id={RowsField[autocomp_name]}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder="--Select--"
                className="max-w-23 text-2xl"
                menuTrigger={"input"}
                isClearable={false}
                isLoading={isLoadingData}
                isReadOnly={is_readonly == true ? true : setColumnDisable(row, RowsField[autocomp_name])}
                isVirtualized
                defaultItems={
                    itemData ? itemData : []
                }
                onSelectionChange={(e) =>
                    handleAutoCompleteChange(row.gridId, e, row.id, RowsField[autocomp_id])
                }
                //onChange={handleFormSelectionChange}
                selectedKey={row[autocomp_id]}
            >
                {(item) => (
                    <AutocompleteItem
                        key={item[itemKey]}
                    >
                        {RowsField[autocomp_name] == RowsField.lwRatio ? item[itemKey] : item[itemKey] + "(" + item[itemValue] + ")"}
                    </AutocompleteItem>
                )}
            </Autocomplete>
        )
    }
    const setColumnRequired = (column) => {
        if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }
    //console.log(mixRows)
    const setColumnDisable = (row, column) => {
        //console.log(isNewEntry, row.detailId)
        const enableCol = ['id', RowsField.dRate, RowsField.rate, RowsField.convRate, RowsField.lotNo, RowsField.pktNo]
        if (row.detailId > 0 && row.bWeight <= 0) {
            return true
        }
        else {
            if (enableCol.includes(column))
                return false
            else
                return true
        }
    }
    const setColumnVisiblity = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
        else
            return true
    }

    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rate, RowsField.stkRate, RowsField.amount]
        const DCol = [RowsField.dRate, RowsField.stkDRate, RowsField.dAmount, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }

    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>
                                {setColumnDisable(row, 'id') ? "" :
                                    <FontAwesomeIcon
                                        color="red"
                                        className={`cursor-pointer`}
                                        onClick={() => handleDeleteRow(row.gridId, row.id)}
                                        icon={faSquareXmark}
                                    ></FontAwesomeIcon>
                                }
                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {funIsFooter(row.id) ? "" : row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.itemMaster ? masterData?.itemMaster : []
                                , "Item_Code", "Item_Desc", row, RowsField.itemCode, RowsField.itemName, true, "", false, "", "danger"
                            )
                        )

                    }

                </div>
            ),
        },
        {
            field: RowsField.lotNo,
            headerName: "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" :
                    (renderInputCell(row, RowsField.lotNo, "text",
                        !isNewEntry && row.detailId > 0 ? true : setColumnDisable(row, RowsField.lotNo),
                        "",
                        setColumnRequired(RowsField.lotNo)
                        , "", ""))
                }</div>

            ),
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",

            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{
                    funIsFooter(row.id) ? "" :
                        renderInputCell(row, RowsField.pktNo, "text",
                            !isNewEntry && row.detailId > 0 ? true : setColumnDisable(row, RowsField.pktNo),
                            ""
                            , setColumnRequired(RowsField.pktNo)
                            , "", "")
                }</div>
            )
        },
        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.shapeMaster ? masterData?.shapeMaster : []
                                , "S_Code", "S_Name", row, RowsField.shapeCode, RowsField.shapeName, true, "", false, "", "warning"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.colorName,
            headerName: "Color",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.colorMaster ? masterData?.colorMaster : []
                                , "Sh_Code", "Sh_Name", row, RowsField.colorCode, RowsField.colorName, true, "", false, "", "success"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.purityMaster ? masterData?.purityMaster : []
                                , "Q_Code", "Q_Name", row, RowsField.purityCode, RowsField.purityName, true, "", false, "", "primary"
                            )
                        )
                    }
                </div>
            ),
        },
        {
            field: RowsField.sizeName,
            headerName: "Size",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.sizeMaster ? masterData?.sizeMaster : []
                                , "Sz_Code", "Sz_Name", row, RowsField.sizeCode, RowsField.sizeName, true, "", false, "", "default"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.lwMaster ? masterData?.lwMaster : []
                                , "LwCode", "LwCode", row, RowsField.lwRatio, RowsField.lwRatio, true, "", false, "", "warning"
                            )
                        )
                    }
                    {/* {
                        funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lwRatio, "text",
                            true,
                            "", false, "", "")
                    } */}
                </div>
            )
        },
        {
            field: RowsField.reportNo,
            headerName: "Report No.",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.reportNo, "text",
                    true,
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lab, "text",
                    true,
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.stkPcs,
            headerName: "Pcs",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >0</div> :
                    renderInputCell(row, RowsField.stkPcs, "number",
                        true,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.stkWeight,
            headerName: "Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">0</div>
                    : renderInputCell(row, RowsField.stkWeight, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.rapRate,
            headerName: "RapRate",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">0</div>
                    : renderInputCell(row, RowsField.rapRate, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.discPer,
            headerName: "Disc%",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">0</div>
                    : renderInputCell(row, RowsField.LessPer, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.stkRate,
            headerName: "Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> 0</div> :
                renderInputCell(row, RowsField.stkRate, "number",
                    true,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.stkDRate,
            headerName: "Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> 0</div> :
                renderInputCell(row, RowsField.stkDRate, "number",
                    true,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.pcs,
            headerName: "Out Pcs",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_OutPcs}</div> :
                    renderInputCell(row, RowsField.pcs, "number", true,
                        // setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Out Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_OutWeight}</div>
                    : renderInputCell(row, RowsField.weight, "number", true,
                        //  setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Out Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_OutRate}</div> :
                renderInputCell(row, RowsField.dRate, "number",
                    setColumnDisable(row, RowsField.dRate),
                    // CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? setColumnDisable(row) : true,

                    "", true, "", "")
            }</div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Out Amount($)",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_OutAmount}</div> : row[RowsField.dAmount]
                    }
                </div>)
        },
        {
            field: RowsField.convRate,
            headerName: "conv.Rate",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" ></div> :
                    renderInputCell(row, RowsField.convRate, "number",
                        setColumnDisable(row, RowsField.convRate),
                        // false,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.rate,
            headerName: "Out Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_OutRate}</div> :
                renderInputCell(row, RowsField.rate, "number",
                    setColumnDisable(row, RowsField.rate),
                    //  CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? setColumnDisable(row,RowsField.rate) : true,
                    "", true, "", "")
            }</div>
            )
        },


        {
            field: RowsField.amount,
            headerName: "Out Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_OutAmount}</div> : row[RowsField.amount]
                    }
                </div>)
        },

        {
            field: RowsField.remarks,
            headerName: "Remarks",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"></div> :
                renderInputCell(row, RowsField.remarks, "text",
                    false,
                    "", false, "", "")
            }</div>
            )
        },

    ]
    const getLwRatioByShape = (shape) => {
        if (masterData && Object.keys(masterData).length > 0)
            return masterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }
    const [errors, setErrors] = useState({})
    const validateForm = () => {
        const newErrors = {}
        if (formData.vouNo == "") {
            newErrors[formField.vouNo] = "Vou No. required"
        }
        if (formData[formField.mDate] == null || formData[formField.mDate] == "" || formData[formField.mDate] == "Invalid Date") {
            newErrors[formField.mDate] = "Date required"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const ValidateGrid = () => {
        let msg = ""

        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
                if (rows[i].pcs == "" || rows[i].pcs == "0") {
                    if (!msg.includes("Pcs"))
                        msg = msg + "  Pcs ,";
                }
                if (rows[i].rate == "" || rows[i].rate == "0") {
                    if (!msg.includes("Rate"))
                        msg = msg + "  Rate ,";
                }
                if (rows[i].weight == "" || rows[i].weight == "0") {
                    if (!msg.includes("Weight"))
                        msg = msg + "  Weight ,";
                }
                if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                    if (rows[i].convRate == "" || rows[i].convRate == "0") {
                        if (!msg.includes("Conv.Rate"))
                            msg = msg + "  Conv.Rate ,";
                    }
                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
        }
        if (msg)
            return msg + " is required";
        else return ""

    }
console.log(formData)

    const handleSubmit = (e) => {
        e.preventDefault()

        const mixData = {
            ...formData, pcs: total_OutPcs, rate: total_OutRate, weight: total_OutWeight, dRate: total_OutRateD,
            convRate: funCheckNumber((parseFloat(Avg_Rate) / parseFloat(Avg_RateD)).toFixed(2)),
            stkPcs: total_OutPcs, stkWeight: total_OutWeight, stkRate: Avg_Rate, stkDRate: Avg_RateD
        }
        const validate_form = validateForm()
        const grid_msg = ValidateGrid()

        if (grid_msg == "" && validate_form) {

            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    trans_id: formData[formField.transId],
                    item_list: rows,
                    mixitem_list: [mixData],
                    deleteditem_list: deletedItemRows,
                    deletedmixitem_list: [],
                    location_id: formData[formField.locationId],
                    vou_no: formData[formField.vouNo],
                    trade_of: selTradeOf,
                    pkt_type: selPktType == 'SNG' ? selPktType : "",
                    m_date: formData[formField.mDate],
                    mkt_lotno: isUseMfgNoAsMktno ? 0 : mktLotNo,
                    login_userid: user.username,
                    entry_type: selMixSlitType,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
        else {
            if (grid_msg != "") {
                addToast({
                    title: "",
                    description: grid_msg,
                    color: "danger"
                })
            }
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            setRows(gridData)

            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {

                setLwRatioData(getLwRatioByShape(detail?.itemData[0]?.MS_Code ?? ""))
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.locationId]: detail?.itemData[0]?.DivId.trim() ?? "",
                    [formField.mDate]: detail?.itemData[0]?.MDate ?? "",
                    [formField.shapeCode]: detail?.itemData[0]?.MS_Code ?? "",
                    [formField.colorCode]: detail?.itemData[0]?.MSha_Code ?? "",
                    [formField.purityCode]: detail?.itemData[0]?.MQ_Code ?? "",
                    [formField.sizeCode]: detail?.itemData[0]?.MSz_Code ?? "",
                    [formField.pktNo]: detail?.itemData[0]?.MPktNo ?? "",
                    [formField.lotNo]: detail?.itemData[0]?.ML_Code ?? "",
                    [formField.sPktNo]: detail?.itemData[0]?.MSPktNo ?? "",
                    [formField.sLotNo]: detail?.itemData[0]?.MSL_Code ?? "",
                    [formField.remarks]: detail?.itemData[0]?.Remark ?? "",
                    [formField.detailId]: detail?.itemData[0]?.DetailId ?? "",
                    [formField.lwRatio]: detail?.itemData[0]?.MLW_Code ?? "",
                    [formField.itemCode]: detail?.itemData[0]?.MItem_Code ?? "",

                })

                setSelMixSlitType(detail?.itemData[0]?.Entry_Type ?? "")

            }
        }

    }, [detail, masterData])
    const funGetMasterLink = () => {
        if (selMixSlitType == 4)
            return naviCode + mtrdtype + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.mixslitEntry.mixslitEntryMaster;
        else
            return naviCode + mtrdtype + "/" + mptype + linksUrl.mixslitEntry.mixslitEntryMaster;
    }
    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const handleAddRow = (id) => {
        let new_initialRow = initialRow
        if (modSettingParams && modSettingParams.Visibility) {

            if (Object.keys(modSettingParams.Visibility).length > 0) {
                //set default value to hidden grid column setting based
                const hiddenCol = Object.entries(modSettingParams.Visibility)
                    .filter(([key, value]) => value == false) // filter where value is true
                    .map(([key, value]) => {
                        return { [key]: modSettingParams.Value[key] }
                    });

                const result = hiddenCol.reduce((acc, current) => {
                    return { ...acc, ...current };
                }, {});

                if (result && Object.keys(result).length > 0)
                    new_initialRow = { ...initialRow, ...result }
            }

        }
        let newId = rows.length + 1
        const newRow = { id: newId, ...new_initialRow, }
        setTimeout(() => {
            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }

        }, 250)
        setTimeout(() => {
            const firstCell = gridContainerRef.current?.querySelector(
                `[data-id="${newId}"] [data-field="id"]`
            );
            if (firstCell) {
                firstCell.focus();
            }
        }, 500);
        setRows([...rows, newRow])

    }
    const handleNewAcEntry = () => {
        let redLink = naviCode + mtrdtype + "/" + mptype + linksUrl.mixEntry.CreateMixSlitEntry
        dispatch(setRedirectLink(redLink))
        navigate(linksUrl.master.account.createAccountMaster)
    }
    const handleRadioChange = (value) => {
        setSelMixSlitType(value)

        setFormData({ ...formData, [formField.lotNo]: "", [formField.pktNo]: "" })
    }
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                [formField.mDate]: cdate,
            };
        });
        if (cdate && cdate != "Invalid Date") {
            funMktLotNo(cdate)
        }
    }

    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        // if (!parsed.isValid()) {
        //     toast.error("Invalid date format. Use DD/MM/YYYY", {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     return;
        // }

        // // ❌ Out of allowed range
        // if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
        //     toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     setFormData({ ...formData, [name]: null })
        //     return;
        // }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");


        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
        if (formatted && formatted != "Invalid Date") {
            funMktLotNo(formatted)
        }
    };
    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Mix Slit Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[entryLabel, "Mix Split Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className="mb-3 w-full shadow p-3 bg-white">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>

                            <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                {
                                    inputBoxes["Row1"].map((item, indx) =>
                                        item.type == ENUM_INPUT_TYPE.select ? (
                                            <></>
                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                            <>
                                                <Autocomplete
                                                    size="md"
                                                    name={item.name}
                                                    isInvalid={errors[item.name]}
                                                    errorMessage={errors[item.name]}
                                                    label={item?.placeholder}
                                                    eventResizeFeature={true}
                                                    selectionMode="single"
                                                    showScrollIndicators={true}
                                                    labelPlacement={"outside"}
                                                    placeholder={item.placeholder}
                                                    isRequired={item.isrequired}
                                                    isLoading={isLoadingData}
                                                    className="max-w-23 text-xs text-black font-semibold"
                                                    classNames={{
                                                        label: "text-xs text-black font-bold",
                                                    }}
                                                    isClearable={false}
                                                    isVirtualized
                                                    readonly={isNewEntry ? false : true}
                                                    defaultItems={
                                                        item.data ? item.data : []
                                                    }
                                                    onSelectionChange={(e) =>
                                                        handleAutoCompleteChange("", e, '', item.name)
                                                    }
                                                    color={"warning"}
                                                    //color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                    //onChange={handleFormSelectionChange}
                                                    selectedKey={formData[item.name]}
                                                >
                                                    {(list) => (
                                                        <AutocompleteItem

                                                            key={list[item.itemkey]}
                                                        >
                                                            {list[item.itemvalue]}
                                                        </AutocompleteItem>
                                                    )}
                                                </Autocomplete>
                                                {item.name == formField.partyId ?
                                                    <Chip className="cursor-pointer bg-slate-400" color={"default"} onClick={handleNewAcEntry}>New A/C.</Chip>
                                                    : ""}
                                            </>
                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                            <div className=" w-full flex items-center">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label={item.placeholder}
                                                        views={["day", "month", "year"]}
                                                        format="DD/MM/YYYY"
                                                        value={
                                                            formData[item.name]
                                                                ? dayjs(formData[item.name])
                                                                : formData[item.name]
                                                        }
                                                        onChange={(newValue) => handleDateChange(newValue)}
                                                        // setFormData((prev) => {
                                                        //     return {
                                                        //         ...prev,
                                                        //         [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                        //             dayjs(newValue).format("YYYY-MM-DD") : null,
                                                        //     };
                                                        // });
                                                        //}}
                                                        //isRequired={item.required}
                                                        className="w-full "
                                                        slotProps={{
                                                            textField: {
                                                                size: "small", error: errors[item.name], helperText: errors[item.name],
                                                                onBlur: (e) => handleDateBlur(e, item.name), required: true
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        ) : (

                                            <Input
                                                type={item.type}
                                                name={item.name}
                                                id={item.name}
                                                isInvalid={errors[item.name]}
                                                errorMessage={errors[item.name]}
                                                placeholder={item.placeholder}
                                                label={item.placeholder}
                                                labelPlacement="outside"
                                                isRequired={item.isrequired}
                                                value={formData[item.name]}
                                                variant="bordered"
                                                onChange={(e) => handleChange(e)}
                                                onBlur={(e) => handleBlur("", "", e, item.name)}
                                                readOnly={item.name == formField.vouNo ? true : false}
                                                size={"md"}
                                                classNames={{
                                                    //inputWrapper:"bg-red-700 h-1 px-2 m-0",
                                                    label: "text-xs text-black font-bold",
                                                }}
                                            ></Input>
                                        )
                                    )
                                }
                            </div>


                            <div>
                                <div className="flex justify-between items-center">
                                    <Button size="sm" color="success" radius="sm" className="text-white cursor-default  text-xs bg-emerald-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                        onPress={() => handleAddRow("")}>
                                        ADD ITEM
                                    </Button>
                                    <h6 className="text-sm text-green-700" >Total Items : {rows && rows.length > 0 ? rows.length : 0}</h6>
                                </div>
                                {rows && rows?.length > 0 ? (
                                    <div>
                                        <Box ref={gridContainerRef} sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                editMode="row"
                                                hideFooterPagination={true}
                                                hideFooter={true}
                                                columnHeaderHeight={30}
                                                rowHeight={43}
                                                disableColumnSorting={true}
                                                disableColumnMenu={true}
                                                getRowClassName={(params) => {
                                                    return 'row-class';
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Make sure the headers are above the rows when scrolling
                                                    },
                                                    '& .row-class': {
                                                        fontSize: "12px",
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                    [RowsField.itemName]: setColumnVisiblity(RowsField.itemCode),
                                                    [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                    [RowsField.pktNo]: setColumnVisiblity(RowsField.pktNo),
                                                    [RowsField.shapeName]: setColumnVisiblity(RowsField.shapeCode),
                                                    [RowsField.colorName]: setColumnVisiblity(RowsField.colorCode),
                                                    [RowsField.purityName]: setColumnVisiblity(RowsField.purityCode),
                                                    [RowsField.sizeName]: setColumnVisiblity(RowsField.sizeCode),
                                                    [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                    [RowsField.reportNo]: setColumnVisiblity(RowsField.reportNo),
                                                    [RowsField.lab]: setColumnVisiblity(RowsField.lab),
                                                    [RowsField.rapRate]: setColumnVisiblity(RowsField.rapRate),
                                                    [RowsField.discPer]: setColumnVisiblity(RowsField.discPer),
                                                    [RowsField.remarks]: setColumnVisiblity(RowsField.remarks),
                                                    [RowsField.stkDRate]: setCurrencyColumnVisiblity(RowsField.stkDRate),
                                                    [RowsField.stkRate]: setCurrencyColumnVisiblity(RowsField.stkRate),
                                                    [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                    [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                    [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                    [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                    [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                }}

                                            />

                                        </Box>

                                        <div className="flex  items-top gap-2 mt-1 bg-slate-100 p-2 ">
                                            <Input size="sm" readOnly={true} label="Packet" labelPlacement="outside" color="primary" value={rows ? rows?.length ?? 0 : 0} className="bg-sky-700"
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">₹</span>
                                                    </div>
                                                }
                                            ></Input>
                                            <Input size="sm" readOnly={true} label="Out Weight" labelPlacement="outside" color="danger" className="bg-rose-700" value={total_OutWeight}
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">₹</span>
                                                    </div>
                                                }> </Input>
                                            <Input size="sm" readOnly={true} label="Pcs" labelPlacement="outside" color="default" className="bg-slate-700" value={total_OutPcs}> </Input>
                                            {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? "" :
                                                <>
                                                    <Input size="sm" readOnly={true} label=" Out Amount" labelPlacement="outside" color="success" className="bg-lime-500" value={total_OutAmount}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">₹</span>
                                                            </div>
                                                        }
                                                    > </Input>
                                                    <Input size="sm" readOnly={true} label="Avg Rate" labelPlacement="outside" color="warning" className="bg-amber-500" value={Avg_Rate}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">₹</span>
                                                            </div>
                                                        }
                                                    >  </Input></>}
                                            {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                                <>
                                                    <Input size="sm" readOnly={true} label=" Out Amount($)" labelPlacement="outside" color="success" className="bg-lime-500" value={total_OutAmountD}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">$</span>
                                                            </div>
                                                        }
                                                    > </Input>
                                                    <Input size="sm" readOnly={true} label="Avg Rate($)" labelPlacement="outside" color="warning" className="bg-amber-500" value={Avg_RateD}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">$</span>
                                                            </div>
                                                        }
                                                    >  </Input></>}
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="mt-3">
                                {
                                    Object.keys(inputBoxes).map((key, ind) => (
                                        <div key={key + ind}>
                                            <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    key != "Row1" ?
                                                        inputBoxes[key].map((item, indx) =>
                                                            item.type == ENUM_INPUT_TYPE.select ? (
                                                                <></>
                                                            ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                                <>
                                                                    <Autocomplete
                                                                        size="md"
                                                                        name={item.name}
                                                                        isInvalid={errors[item.name]}
                                                                        errorMessage={errors[item.name]}
                                                                        label={item?.placeholder}
                                                                        eventResizeFeature={true}
                                                                        selectionMode="single"
                                                                        showScrollIndicators={true}
                                                                        labelPlacement={"outside"}
                                                                        placeholder={item.placeholder}
                                                                        isRequired={item.isrequired}
                                                                        isLoading={isLoadingData}
                                                                        className="max-w-23 font-semibold text-red-900 text-xs"
                                                                        classNames={{
                                                                            base: "text-xs text-black font-bold",
                                                                        }}
                                                                        isClearable={false}
                                                                        isVirtualized
                                                                        readonly={isNewEntry ? false : true}
                                                                        defaultItems={
                                                                            item.data ? item.data : []
                                                                        }
                                                                        onSelectionChange={(e) =>
                                                                            handleAutoCompleteChange("", e, '', item.name)
                                                                        }
                                                                        color={"default"}
                                                                        variant="bordered"
                                                                        //onChange={handleFormSelectionChange}
                                                                        selectedKey={formData[item.name]}
                                                                    >
                                                                        {(list) => (
                                                                            <AutocompleteItem

                                                                                key={list[item.itemkey]}
                                                                            >
                                                                                {list[item.itemvalue]}
                                                                            </AutocompleteItem>
                                                                        )}
                                                                    </Autocomplete>
                                                                    {/* {item.name == formField.partyId ?
                                                                        <Chip className="cursor-pointer bg-slate-400" color={"default"} onClick={handleNewAcEntry}>New A/C.</Chip>
                                                                        : ""} */}
                                                                </>
                                                            ) : (

                                                                <Input
                                                                    type={item.type}
                                                                    name={item.name}
                                                                    id={item.name}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    placeholder={item.placeholder}
                                                                    label={item.placeholder}
                                                                    labelPlacement="outside"
                                                                    isRequired={
                                                                        selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.SingleToMix && (item.name == RowsField.pktNo || item.name == RowsField.lotNo) ? false :
                                                                            selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.SingleToSingle && (item.name == RowsField.lwRatio) ? false :
                                                                                item.isrequired}
                                                                    value={formData[item.name]}
                                                                    variant="bordered"
                                                                    isDisabled={!isNewEntry && selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.SingleToSingle
                                                                        && (item.name == RowsField.lotNo || item.name == RowsField.pktNo) ? true :

                                                                        false
                                                                    }
                                                                    onChange={(e) => handleChange(e)}
                                                                    onBlur={(e) => handleBlur("new", "", e, item.name)}
                                                                    readOnly={item.name == formField.vouNo ? true : false}
                                                                    size={"md"}
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                ></Input>
                                                            )
                                                        )
                                                        : ""
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className=" p-2 border-1 mt-3 items-center">
                                <RadioGroup orientation="horizontal"
                                    // isInvalid={errors["mixSlitType"]}
                                    //errorMessage={errors["mixslitType"]}
                                    isRequired
                                    isReadOnly={isNewEntry ? false : true} className="w-full" size="sm" color="success" value={selMixSlitType}
                                    onValueChange={handleRadioChange}>
                                    <Radio isDisabled={ClientSetting == ENUM_CLIENT_SETTING_VAL.SINGLE ? true : false}
                                        value={ENUM_MIXSLIT_ENTRYTYPE.SingleToMix}>Single To Mix</Radio>
                                    <Radio value={ENUM_MIXSLIT_ENTRYTYPE.SingleToSingle}>Single To Single</Radio>
                                    {isNewEntry ? "" : <Radio value={ENUM_MIXSLIT_ENTRYTYPE.MixToSingle}>Mix To Single</Radio>}
                                </RadioGroup>

                            </div>


                            <div className="justify-center flex gap-5 mt-5">

                                <Button
                                    color="primary"
                                    type="submit"
                                    size="md"
                                    variant="shadow"
                                    isDisabled={isDisableSubmit()}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="md"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </CardBody>
                    </form >
                </Card >
            </MainContainer>
        </div >
    )

}
export default CreateSingleMixSlitEntry
